import api from '@/common/api';
import handler from './apiResultValidator';

/**
 * マニュアルを別ウィンドウで表示する
 * @param {object} self this インスタンス
 * @param {string} type マニュアル種別
 */
export async function openManual(self, type) {
  const endPoint = `/downloadUrl/manuals?type=${type}&country_group=${self.userProperty.region}&language=${self.language}`;
  const response = await api.getCall(api.ADMIN, endPoint);
  handler.validate(
    handler.validateTypes.all, response, self, null,
    () => {
      // 処理が成功したときのコールバック処理
      window.open(`${response.data.fileUrl}`, '_blank', 'width=1270,height=720');
    },
    (result) => {
      // 処理が失敗したときのコールバック処理
      if (result.behaviorType === handler.behaviorTypes.logout) {
        self.logout(self);
      }
    }
  );
}